export enum AppRoute {
    AccountMfa = '/account/mfa',
    Analyze = '/analyze2',
    AnalyzeDiversity = '/analyze2/diversity',
    AnalyzeInclusion = '/analyze2/inclusion',
    AnalyzeV1 = '/analyze',
    AnalyzeDiversityV1 = '/analyze/diversity',
    AnalyzeInclusionV1 = '/analyze/inclusion',
    ChooseDashboard = '/choose-dashboard',
    Default = '/',
    Error = '/error',
    EnableMFA = '/enroll-mfa',
    SaveBackupCodes = '/save-backup-codes',
    ForgotPassword = '/forgot-password',
    Home = '/home2',
    HomeV1 = '/home',
    IlnDashboardHome = '/iln-dashboard/home',
    Login = '/login',
    Programs = '/programs',
    Recommended = '/recommended',
    Register = '/register',
    ResetPassword = '/reset-password/:token',
    SelfServeRegister = '/self-serve-register',
    SendVerificationCode = '/send-verification-code',
    SolutionGoals = '/goals',
    Sso = '/sso',
    SsoCallback = '/sso/callback',
    Survey = '/survey',
    TwoStepVerification = '/two-step-verification',
    TwoStepVerificationBackup = '/two-step-verification-backup',
    Resources = '/resources',
    MySolutions = '/my-solutions',
    Lumi = '/lumi',
    Intro = '/intro',
    PulseSurvey = '/pulse-survey',
    PulseSurveyTemplates = '/pulse-survey/templates',
    PulseSurveyCreate = '/pulse-survey/:id/create',
    PulseSurveyResults = '/pulse-survey/:id/results',
    PulseSurveyStatus = '/pulse-survey/:id/status',
    PulseSurveyRespondents = '/psr/:id/',
}
